import React, { useState } from 'react';
import  {Rating as ReactStars} from 'react-custom-rating-component'; // For star rating
import toast, { Toaster } from 'react-hot-toast'; // For toast notifications
import { useNavigate } from 'react-router-dom';
import { useAddOnboardingFeedback } from '../../hooks/api/post';

const OnboardingFeedback: React.FC = () => {
    const navigate = useNavigate();
const onboardingFeedbackAPI= useAddOnboardingFeedback()
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
const email= sessionStorage.getItem("email") || ""

  const handleRatingChange = (newRating: number) => {
    setRating(newRating);
  };

  const handleCommentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(event.target.value);
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
        onboardingFeedbackAPI.mutate({
            comment,
            rating,
            email
        }, {
            onSuccess(){
                toast.success('Thank you for your feedback!', {
                    duration: 3000, // Duration in milliseconds
                  });
                  setRating(0);
                  setComment('');
                  navigate("/register/successful-registration")
            },
            onError(error){

                toast.error('Failed to submit feedback. Please try again later.', {
                    duration: 3000,
                  });
                  console.error('Error submitting feedback:', error);
            },

            onSettled(){
                setSubmitting(false);
            }
        })


      // Simulate API call (replace with your actual API endpoint)
      await new Promise(resolve => setTimeout(resolve, 2000)); // 2-second delay

      // In a real application, you would send the rating and comment to your backend here.
      console.log('Rating:', rating);
      console.log('Comment:', comment);

    

     
    } catch (error) {
      toast.error('Failed to submit feedback. Please try again later.', {
        duration: 3000,
      });
      console.error('Error submitting feedback:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <Toaster /> {/* Toast container */}
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          Thank you for completing onboarding!
        </h2>
        <p className="text-gray-600 mb-6 text-center">
          Kindly rate your onboarding experience:
        </p>

        <div className="flex justify-center mb-6">
          <ReactStars

            count={5}
            onChange={handleRatingChange}
            size="40px"
            activeColor="#facc15" // Yellow color for active stars
            defaultColor="#e2e8f0" // Light gray for empty stars
            defaultValue={rating}
            // isHalf={false} // Set to true if you want half-star ratings
          />
        </div>

        <div className="mb-6">
          <label htmlFor="comment" className="block text-gray-700 font-medium mb-2">
            Comments (Optional)
          </label>
          <textarea
            id="comment"
            rows={4}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Tell us about your experience..."
            value={comment}
            onChange={handleCommentChange}
          />
        </div>

        <button
          onClick={handleSubmit}
          disabled={submitting}
          className={`w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 ${
            submitting ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          {submitting ? 'Submitting...' : 'Submit Feedback'}
        </button>
      </div>
    </div>
  );
};

export default OnboardingFeedback;